import { Utils } from '@adobe/aem-react-editable-components';
import LOGO_AVA from 'assets/pics/tenantLogos/logo_avacon.png';
import LOGO_BAG from 'assets/pics/tenantLogos/logo_bag.png';
import LOGO_EDI from 'assets/pics/tenantLogos/logo_edis.png';
import LOGO_LVN from 'assets/pics/tenantLogos/logo_lvn.png';
import LOGO_MTN from 'assets/pics/tenantLogos/logo_mtn.png';
import LOGO_SHNG from 'assets/pics/tenantLogos/logo_sh-netz.png';

import { PFLEGENDE_BU, STORAGE_KEY, TENANT_ID } from 'global/constants';

import { isDevelopment, isLocal, isStaging } from './StageUtils';

export const GRIDNET_PROVIDER = {
  [TENANT_ID.EDI]: {
    EDI: 35,
  },
  [TENANT_ID.SHNG]: (() => {
    if (isLocal() || isDevelopment()) {
      return {
        SHNG: 36,
        EENG: 1560,
        NNNG: 1569,
        HANSG: 1568,
      };
    }
    if (isStaging()) {
      return {
        SHNG: 36,
        EENG: 1560,
        NNNG: 1567,
        HANSG: 1566,
      };
    }
    return {
      SHNG: 36,
      EENG: 1560,
      NNNG: 1581,
      HANSG: 1534,
    };
  })(),
  [TENANT_ID.AVA]: {
    AVA: 32,
  },
  [TENANT_ID.BAG]: {
    BAG: 33,
  },
  [TENANT_ID.LVN]: {
    LVN: 442,
  },
  [TENANT_ID.MTN]: (() => {
    if (isLocal() || isDevelopment()) {
      return {
        MTNSTROM: 190,
        MTNGAS: 459,
        MTNPLAUEN: 1192,
      };
    }
    if (isStaging()) {
      return {
        MTNSTROM: 190,
        MTNGAS: 1520,
        MTNPLAUEN: 1192,
      };
    }
    return {
      MTNSTROM: 190,
      MTNGAS: 1520,
      MTNPLAUEN: 1192,
    };
  })(),
};

export const PFLEGENDE_BU_TO_GRIDNET_PROVIDER = {
  [TENANT_ID.EDI]: {
    [PFLEGENDE_BU.EDI[TENANT_ID.EDI]]: GRIDNET_PROVIDER[TENANT_ID.EDI].EDI,
  },
  [TENANT_ID.SHNG]: {
    [PFLEGENDE_BU.SHNG.SHNG]: GRIDNET_PROVIDER[TENANT_ID.SHNG].SHNG,
    [PFLEGENDE_BU.SHNG.EENG]: GRIDNET_PROVIDER[TENANT_ID.SHNG].EENG,
    [PFLEGENDE_BU.SHNG.NNNG]: GRIDNET_PROVIDER[TENANT_ID.SHNG].NNNG,
    [PFLEGENDE_BU.SHNG.HANSG]: GRIDNET_PROVIDER[TENANT_ID.SHNG].HANSG,
  },
  [TENANT_ID.AVA]: {
    [PFLEGENDE_BU.AVA[TENANT_ID.AVA]]: GRIDNET_PROVIDER[TENANT_ID.AVA].AVA,
    [PFLEGENDE_BU.AVA.WEVG]: GRIDNET_PROVIDER[TENANT_ID.AVA].AVA,
  },
  [TENANT_ID.BAG]: {
    [PFLEGENDE_BU.BAG[TENANT_ID.BAG]]: GRIDNET_PROVIDER[TENANT_ID.BAG].BAG,
  },
  [TENANT_ID.MTN]: {
    [PFLEGENDE_BU[TENANT_ID.MTN].MTNSTROM]: GRIDNET_PROVIDER[TENANT_ID.MTN].MTNSTROM,
    [PFLEGENDE_BU[TENANT_ID.MTN].MTNGAS]: GRIDNET_PROVIDER[TENANT_ID.MTN].MTNGAS,
  },
  [TENANT_ID.LVN]: {
    [PFLEGENDE_BU.LVN[TENANT_ID.LVN]]: GRIDNET_PROVIDER[TENANT_ID.LVN].LVN,
  },
};

const TENANT_INFO = {
  [TENANT_ID.EDI]: {
    subDomain: 'edis',
    aemPath: 'edis',
    logo: LOGO_EDI,
  },
  [TENANT_ID.SHNG]: {
    subDomain: 'sh-netz',
    aemPath: 'shng',
    logo: LOGO_SHNG,
  },
  [TENANT_ID.AVA]: {
    subDomain: 'avacon',
    aemPath: 'avacon',
    logo: LOGO_AVA,
  },
  [TENANT_ID.BAG]: {
    subDomain: 'bayernwerk',
    aemPath: 'bag',
    logo: LOGO_BAG,
  },
  [TENANT_ID.LVN]: {
    subDomain: 'lew-verteilnetz',
    aemPath: 'lvn',
    logo: LOGO_LVN,
  },
  [TENANT_ID.MTN]: {
    subDomain: 'mitnetz',
    aemPath: 'mtn',
    logo: LOGO_MTN,
  },
};
const getTenantIdFromEnv = () => process.env.REACT_APP_TENANT_ID;
const getTenantIdFromUrl = () => {
  if (isLocal()) {
    return Object.keys(TENANT_ID).find((tenantId) =>
      window.location.pathname.includes(TENANT_INFO[tenantId].aemPath)
    );
  }
  return Object.keys(TENANT_ID).find((tenantId) =>
    window.location.host.includes(TENANT_INFO[tenantId].subDomain)
  );
};
export const getTenantId = () => {
  const isSPAEditor = Utils.isInEditor();
  const tenantIdLocalStorage = localStorage.getItem(STORAGE_KEY.TENANT_ID);
  if (!isSPAEditor && tenantIdLocalStorage) {
    return tenantIdLocalStorage;
  }
  // env is only set for clientLib generation (see npm run build:clientLib:${tenantId}})
  const tenantIdEnv = getTenantIdFromEnv();
  const tenantIdUrl = getTenantIdFromUrl();
  // fallback is EDI, but should never happen
  const tenantId = tenantIdEnv || tenantIdUrl || TENANT_ID.EDI;
  localStorage.setItem(STORAGE_KEY.TENANT_ID, tenantId);
  return tenantId;
};
export const getTenantInfo = (tenantId) => {
  const actualTenantId = tenantId || getTenantId();
  return TENANT_INFO[actualTenantId];
};
export const getBUEmail = (tenantId) => {
  const emails = {
    [TENANT_ID.AVA]: 'netzanschluss@avacon.de',
    [TENANT_ID.BAG]: 'installateure@bayernwerk.de',
    [TENANT_ID.EDI]: 'installateurbetreuung@e-dis.de',
    [TENANT_ID.SHNG]: 'installateurverzeichnis-strom@sh-netz.com',
    [TENANT_ID.LVN]: 'map@lew-verteilnetz.de',
    [TENANT_ID.MTN]: 'Installateure@mitnetz-strom.de',
  };
  return emails[tenantId || getTenantId()];
};

export const getTenantIdByBU = (buNumber) => {
  for (const [tenantId, buObj] of Object.entries(PFLEGENDE_BU)) {
    if (Object.values(buObj).includes(String(buNumber))) {
      return tenantId;
    }
  }
  return null;
};

export const withTenant = (testId) => `${testId}-${getTenantId()}`;
export const isBUofCurrentTenant = (buId) => {
  const tenantId = getTenantId();

  return Object.values(PFLEGENDE_BU[tenantId]).includes(buId);
};

export const isGridnetProviderOfCurrentTenant = (id) => {
  const tenantId = getTenantId();

  return Object.values(GRIDNET_PROVIDER[tenantId]).includes(id);
};

export const getDefaultPflegendeBUForCurrentTenant = () => {
  const tenantId = getTenantId();
  const pflegendeBUs = PFLEGENDE_BU[tenantId];

  if (!pflegendeBUs) {
    return '';
  }

  return Object.values(pflegendeBUs)[0];
};
